import {initializeApp} from 'firebase/app';
import {getAnalytics, logEvent as logAnalyticsEvent, Analytics} from 'firebase/analytics';
import {getPerformance, trace} from 'firebase/performance';

import {keysByHost} from 'presentation/constants';
import {firebaseConfig} from '../config/firebaseConfig';

type FoundKeyType = 'beneficiario' | 'ccg' | 'clinipam' | 'gndiminas' | 'gndi';

const hostName = window.location.hostname.replace(/^www\./, '');
const foundKey = Object.keys(keysByHost).find(key => hostName.includes(key)) as FoundKeyType;
const appConfig = foundKey ? firebaseConfig[foundKey] : firebaseConfig.beneficiario;

const app = initializeApp(appConfig);
const analytics: Analytics = getAnalytics(app);
const perf = getPerformance(app);

export {analytics, logAnalyticsEvent, perf, trace};
